import { render, staticRenderFns } from "./popupView.vue?vue&type=template&id=bbdf3736&scoped=true"
import script from "./popupView.vue?vue&type=script&lang=js"
export * from "./popupView.vue?vue&type=script&lang=js"
import style0 from "./popupView.vue?vue&type=style&index=0&id=bbdf3736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdf3736",
  null
  
)

export default component.exports